<app-kontable
        [source]="educationService.educations"
        [title]=" 'education.sectionTitle' | translate"
        [columns]="['id', 'title', 'description']"
        [titles]="['common.id', 'education.title', 'education.description']"
        [showInfoButton]="false"
        [showGlobalFilter]="false"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)"
>
</app-kontable>

<p-dialog
        *ngIf="addEditDialog"
        header="{{modalTitle}}"
        [(visible)]="addEditDialog"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
        [width]="500"
        (onHide)="closeAddDialog()">
  <kv-education-form
    (educationAdded)="educationAdded($event)"
    (educationUpdated)="educationUpdated($event)"
    *ngIf="educationService.educationEditing"
    [dialogBoxEducation]="educationService.educationEditing"
  ></kv-education-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/education/education.component.html